module.exports = __webpack_public_path__ + "img/123.3d85627a.png";